export default {
    name : 'clickOutside',
    inserted(el,binding, vnode) {
        var anchor = binding.arg === 'anchor' || binding.modifiers.anchor;
        var p = vnode.context.$el;
        const handler = (e) => {
            const TARGET = e.target;
            if(el === TARGET) return;
            if(el.contains(TARGET)) return;
            if(anchor && p.contains(TARGET)) return;
            binding.value(e)
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener('mousedown', el.__vueClickOutside__);
        window.addEventListener('wheel', binding.value);
        el.addEventListener('wheel', stopAction);
    },
    unbind(el,binding,vnode) {
        var p = el.parentNode;
        if(p){p.removeChild(el)};
        document.removeEventListener('mousedown', el.__vueClickOutside__);
        window.removeEventListener('wheel', binding.value);
        el.removeEventListener('wheel', stopAction);
        delete el.__vueClickOutside__;
    }
}

function stopAction(e) {e.stopPropagation()}